import { render, staticRenderFns } from "./SalarySheetDetail.vue?vue&type=template&id=1116fe08"
import script from "./SalarySheetDetail.vue?vue&type=script&lang=js"
export * from "./SalarySheetDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports